import './App.css';
import React, { Component } from 'react';
import VerifyUser from './VerifyUser';
import addHookTo from './AddHookTo';
import { getToken, setUserSession ,getLocaleLanguage} from './AuthService';
import { Navigate } from 'react-router';
import { FormattedMessage,IntlProvider } from 'react-intl';
import { messages, options, severProperties} from './utility/Constants';
import Button from '@mui/material/Button';

class VerifyOtp extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      locale: 'en',
      countdown: '300',
      resendTime: '05:00',
      isEnabled: false,
    };
   }

  startCountdown = () => {
    this.interval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown > 0) {
          let newTime = prevState.countdown - 1;
          let minHrTIme = String((parseInt(newTime/60))).padStart(2, '0') +":"+String((newTime%60)).padStart(2, '0')
          return { countdown: newTime, resendTime: minHrTIme, isEnabled: false };
        } else {
          clearInterval(this.interval);
          return { isEnabled: true }; // Enable button when countdown is done
        }
      });
    }, 1000);
  };


  componentWillUnmount() {
    this.setState({ locale: getLocaleLanguage() });
    
    clearInterval(this.interval);
  }
  componentDidMount() {
    this.setState({ locale: getLocaleLanguage() });
    this.startCountdown();
  }

  handleLanguageChange = (e) => {
    this.setState({ locale: e.target.value });
    localStorage.setItem('laguagePrefered',e.target.value);
};

  resendOtp = () => {

    let formData = new FormData();
        formData.append('aplReferenceId', sessionStorage.getItem("user"));
        formData.append('token', sessionStorage.getItem("token"));
    let status;
        fetch([severProperties.serverURL,"/auth/resend-otp"].join(""), {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': severProperties.serverCORS,
          'Access-Control-Allow-Methods': 'POST' // supported methods
        },
        body: formData,
        })
        .then((response) => {status=response.status; return response.text()})
        .then((result) => {
          if (status=== 403 || status!== 200 || result === "") {
            this.setState({ countdown: 300, resendTime: '05:00', isEnabled: false }, this.startCountdown);
          } else {
            setUserSession(result, '', sessionStorage.getItem("user"));
            <Navigate to="/" />
          }
        })
        .catch((error)=>{
          this.setState({ errorMessage: <div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}>We're experiencing connectivity issues. Please check your network settings or try again later. If the problem persists, contact support for assistance. </div>}); 
        });

    this.setState({ countdown: 300, resendTime: '05:00', isEnabled: false }, this.startCountdown);
  };


  render() {
    const { resendTime, isEnabled } = this.state;
    if ((getToken() === "" || getToken() === null)) {
      return (<Navigate to="/" />);
    }
    return (
      <div className='main-div'>
        <center>
      <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]} defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
        <div className="gfg-div">
          <div className="gfg-logo"></div>
          <div className="gfg-title">JIMS Applicant Portal</div>
          <div className="gfg-sub-title">Let's get started by filling out the form below</div>
          <center> <FormattedMessage id="resendMsg" /></center>
          <VerifyUser />

          <center style={{ marginTop: 30 }}>
            {isEnabled ? (
               <Button onClick={this.resendOtp}><b>Resend OTP </b></Button>
            ) : (
              <><FormattedMessage id="otpMsg" />  {resendTime}  <FormattedMessage id="second" /></>
            )}
            <p />
              <select onChange={this.handleLanguageChange}
                                value={this.state.locale} style={{width:'98%',height:'40px',borderBlockStyle:'dotted',boxShadow:'-moz-initial',borderColor:'blue',borderRadius:4,marginBottom:20}}>
                                  {options.map(option=>
                                    (<option key={option.label} value={option.value}>{option.label}</option>)
                                  )
                                  }
                                </select>
          </center>
        </div> </IntlProvider>
        </center>
        </div>
    );
  }
}
//export default VerifyOtp;
export default addHookTo(VerifyOtp);
